import { prepareSortedOptions } from '../../prepareOptions';
import {
  HANDS_FREE_KIT,
  MP3,
  CD_PLAYER,
  NAVIGATION_SYSTEM,
  HAS_CD_MULTICHANGER,
  HAS_INTEGRATED_MUSIC_STREAMING,
  HAS_TV,
  HAS_WIFI_HOTSPOT,
  HAS_TOUCHSCREEN,
  HAS_VIRTUAL_COCKPIT,
  HAS_ANDROID_PHONE_CONNECTION,
  HAS_APPLE_CARPLAY,
  HAS_BLUETOOTH,
  HAS_SMARTPHONE_INDUCTION_CHARGER,
} from './values';

export default prepareSortedOptions([
  {
    value: HANDS_FREE_KIT,
    label: __('carDetails.equipmentGroups.handsFreeSystem'),
  },
  {
    value: MP3,
    label: __('carDetails.equipmentGroups.mp3UsbiPodInterface'),
  },
  {
    value: CD_PLAYER,
    label: __('carDetails.radioSystemType.radioCd'),
  },
  {
    value: NAVIGATION_SYSTEM,
    label: __('carDetails.equipmentGroups.navigationSystem'),
  },
  {
    value: HAS_CD_MULTICHANGER,
    label: __('carDetails.features.hasCDMultichanger'),
  },
  {
    value: HAS_INTEGRATED_MUSIC_STREAMING,
    label: __('carDetails.features.hasIntegratedMusicStreaming'),
  },
  {
    value: HAS_TV,
    label: __('carDetails.features.hasTV'),
  },
  {
    value: HAS_WIFI_HOTSPOT,
    label: __('carDetails.features.hasWifiHotSpot'),
  },
  {
    value: HAS_TOUCHSCREEN,
    label: __('carDetails.features.hasTouchscreen'),
  },
  {
    value: HAS_VIRTUAL_COCKPIT,
    label: __('carDetails.features.hasVirtualCockpit'),
  },
  {
    value: HAS_ANDROID_PHONE_CONNECTION,
    label: __('carDetails.features.hasAndroidPhoneConnection'),
  },
  {
    value: HAS_APPLE_CARPLAY,
    label: __('carDetails.features.hasAppleCarplay'),
  },
  {
    value: HAS_BLUETOOTH,
    label: __('carDetails.features.hasBluetooth'),
  },
  {
    value: HAS_SMARTPHONE_INDUCTION_CHARGER,
    label: __('carDetails.features.hasSmartphoneInductionCharger'),
  },
]);
